module.exports = __webpack_public_path__ + "static/media/monkey-white.3194e361.png";